import { generateUuid } from './generateUuid'
import type { ReturnedMessage } from '@/services/recommendation'
import { validateRole } from '@/services/utils/mapper'
import type { Character, Message } from '@/types'

export function returnedMessageToMessage(
  returnedMessage: ReturnedMessage,
  chars: Character[],
): Message | undefined {
  let charName = ''
  let role = validateRole(returnedMessage.role)

  if (returnedMessage.role === 'narrator') {
    role = 'narration'
  }
  else {
    const char = chars.find(c => c.charName === returnedMessage.name)
    if (char === undefined) {
      console.warn(`char not found for ${returnedMessage.name}`)
      return undefined
    }
    charName = char.charName
  }

  return {
    messageId: generateUuid(),
    charOrUserId: returnedMessage.charOrUserId,
    name: charName,
    role,
    action: returnedMessage.action,
    message: returnedMessage.message,
    messageTimestampUtc: returnedMessage.messageTimestampUtc || Date.now(),
  }
}
